import { HttpClient } from '@opallabs/api'
import removeMessage from '../removeMessage'

const deleteMessage = ({ messageId }) =>
  HttpClient().delete(`/messages/v1/${messageId}`)

const destoryMessage = (options) => (dispatch) =>
  deleteMessage(options)
    .then((response) => {
      if (response.status === 200) {
        dispatch(removeMessage(options.annotationId))
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default destoryMessage
